<script>
  import { fade, fly } from "svelte/transition";
  import { tourFunctions } from "../tour-functions.js";
  import { tick } from "svelte";

  export let isStatic = false; // static vs animated title
  export let tour = null;

  let title;
  let category;
  let timer;

  animateTitle();

  function getTitle() {
    let currentTitle = tourFunctions.currentScene.getTitle();
    return tourFunctions.parseContent(currentTitle);
  }

  function getCategory() {
    const sceneId = tourFunctions.currentScene.getId();
    return tourFunctions.getSceneCategoryName(tour, sceneId);
  }

  async function animateTitle() {
    clearTimeout(timer);
    title = getTitle();
    category = getCategory();

    if (!isStatic) {
      await tick(); // make sure the title is rendered
      timer = setTimeout(() => {
        title = null; // trigger animation
        category = null;
      }, 5000);
    }
  }

  function animationIn(node, params) {
    return fly(node, { y: 30, duration: 2000 });
  }

  function animationOut(node, params) {
    return fade(node, { duration: 1000 });
  }

  addEventListener("krpano:newpano", async (e) => {
    if (e.detail.scene) {
      animateTitle();
    }
  });
</script>

{#key title}
  {#if title}
    <div
      class="scene-title"
      in:animationIn={!isStatic}
      out:animationOut={!isStatic}
    >
      {#if category}
        <span class="scene-category">{category}</span>
      {/if}
      <h1>{@html title}</h1>
    </div>
  {/if}
{/key}

<style>
  .scene-title {
    position: fixed;
    bottom: 55px;
    left: 50%;
    transform: translateX(-50%);

    z-index: 99;

    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.4em;

    width: 100%;
    box-sizing: border-box;
    padding: 0 1em;
    margin-block: 1rem;
    text-align: center;
    pointer-events: none;
  }

  .scene-category {
    font-family: var(--font-body), sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    background: #525252e6;
    border-radius: 999px;
    padding: 0.25em 0.75em;
    line-height: 1.3;
    text-shadow: none;
  }

  h1 {
    margin: 0;

    font-family: var(--font-body), sans-serif;
    font-size: 28px;
    font-weight: 500;
    color: #fff;
    text-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);
  }

  /* mobile */
  @media (max-width: 768px) {
    .scene-category {
      font-size: 12px;
    }

    h1 {
      font-size: 22px;
    }
  }
</style>
